import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import {on, debounce, Options} from "../utils/decorators";
import * as Cookies from 'js-cookie';

const IE11 = window.navigator.userAgent.indexOf('Trident/7.0') > -1;

@Options({
    template: false,
    ui: {

    },
})
export default class DonationPopupView extends Marionette.View<Backbone.Model>{
    widgetID: number;
    element: HTMLElement;
    widget: HTMLElement;
    timer: number;
    isVisible: boolean;

    constructor(options?:object) {
        super(options);

        this.element = this.$el.get(0);
        this.widgetID = +this.element.getAttribute('data-id');
        this.timer = +this.element.getAttribute('data-timer');

        this.widget = document.querySelector(`.donation-widget[data-id="${this.widgetID}"]`);
    }


    onRender() {
        if(this.timer) {
            setTimeout(() => this.show(), this.timer);
        }

        this.element.addEventListener('click', event => {
            let classes:DOMTokenList = this.widget.classList;
            if (classes.contains('visible')) {
                this.hide();
            } else {
                this.show();
            }
        });

        document.addEventListener('click', event => {

            // console.log((event.target as HTMLElement).classList.contains('donation-widget__close'));
            
            if(
                !((event.target as HTMLElement).closest(`.donation-widget[data-id="${this.widgetID}"], .donation-popup[data-id="${this.widgetID}"]`))
                || (event.target as HTMLElement).classList.contains('donation-widget__close')
                ) {
                this.hide();
            }
        })
    }

    show() {
        if(this.isVisible) return;

        let buttonRect = this.element.getBoundingClientRect();

        this.widget.classList.add('visible');

        let widgetRect = this.widget.getBoundingClientRect();

        let x = (buttonRect.left + (buttonRect.width / 2)) - (widgetRect.width / 2);

        this.widget.style.left = `${x}px`;

        widgetRect = this.widget.getBoundingClientRect();
        let w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

        if (widgetRect.left < 0) {
            this.widget.style.left = `20px`;
        } else if (widgetRect.right >= w) {
            this.widget.style.right = `${Math.floor(w-20)}px`;
        }

        this.isVisible = true;
    }

    hide() {
        if(!this.isVisible) return;

        this.widget.classList.remove('visible');
        this.isVisible = false;
    }
}



// WEBPACK FOOTER //
// ./@modules/views/donation-popup-view.ts